import { useState } from 'react';

export default () => {
  const [modal, setModal] = useState(false);
  const [closeCb, setCloseCallback] = useState(null);
  const [modalTitle, setModalTitle] = useState(null);
  const [modalContent, setModalContent] = useState(null);
  const [modalAction, setModalAction] = useState(true);

  const closeModal = () => {
    setModal(false);
    setModalTitle(null);
    setModalContent(null);
    setModalAction(true);
    if (closeCb) closeCb();
  };
  const handleModal = (title = false, content = false, closeCallback, action = true) => {
    setModal(!modal);
    setModalAction(action);
    setCloseCallback(closeCallback);
    if (title) {
      setModalTitle(title);
    }
    if (content) {
      setModalContent(content);
    }
  };

  return { modal, closeModal, handleModal, modalTitle, modalContent, modalAction };
};
